import React, { Component } from 'react';
import { userStatus, envConfig, history } from '../../../_helpers';
import { Loader } from '../../../_components';
import * as chartjs from 'chart.js';
import 'chartjs-plugin-datalabels';
import queryString from 'query-string';

chartjs.defaults.global.plugins.datalabels.align = 'end'; 

export default class OriginPageview extends Component {
  constructor(props) {
    super(props);

    this.state = {
      endpoint: this.props.endpoint,
      domain: '',
      labels: [],
      values: [],
      loaded: false
    }

    this.chartRef = React.createRef();
  }

  async componentDidMount() {
    if ( sessionStorage.getItem('selected_domain') ) {
      let data = await JSON.parse(sessionStorage.getItem('selected_domain'));
      this.listAnalyticsData(data.uuid);
    }
  }

  async componentWillReceiveProps(nextProps) {
    await this.setState({
      loaded: false,
      period: nextProps.period,
      domain: queryString.parse(history.location.search).domain
    }, () => this.listAnalyticsData(this.state.domain, nextProps.period));
  }
  
  async listAnalyticsData(domain) {
    const user = userStatus();
    let { endpoint } = this.state;

    let url = `${envConfig.ANALYTICS_API_URL}/analytics/${domain}${endpoint}?period=${this.props.period}`;
    let options = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${user.bearer_token}`
      }
    }

    let request = await fetch(url, options);

    if ( request.status !== 200 ) Promise.reject(await request.json());
    let response = await request.json();
    
    if ( response.data.length === 0 ) {
      return this.setState({loaded: true});
    }
    
    let labels = [];
    let values = [];

    response.data.map(data => {
      labels.push(data.url);
      values.push(data.count);
      return true
    });

    this.setState({labels: labels, values: values, loaded: true});

    this.originChart = new chartjs(this.chartRef.current, {
      type: 'bar',
      data: {
        labels: this.state.labels,
        datasets: [{
          label: 'Origens Totais (Top 10)',
          data: this.state.values,
          backgroundColor: [
            'rgb(255, 224, 230)',
            'rgb(214, 236, 251)',
            'rgb(218, 250, 213)',
            'rgb(254, 255, 224)',
            'rgb(172, 182, 229)',
            'rgb(255, 167, 81)',
            'rgb(51, 77, 80)',
            'rgb(0, 65, 106)',
            'rgb(238, 156, 167)',
            'rgb(33, 147, 176)'
          ],
        }]
      },
      options: {
        plugins: {
          datalabels: {
              color: 'black',
              labels: {
                  title: {
                      font: {
                          weight: 'semibold'
                      }
                  }
              }
          }
        },
        scales: {
          yAxes: [{
            minBarLength: 5
          }]
        },
        responsive: true
      }
    });
  }

  render() {
    return (
      <div className="col-xs-12 col-sm-6 col-md-4 col-lg-4">
        <div className="card">
          <p className="title title-outside">{this.props.title}</p>
          {
            this.state.labels && this.state.values && this.state.loaded === true ?
            <canvas id="originChart" ref={this.chartRef} />
            : <Loader className="is-blue" />
          }
        </div>
      </div>
    )
  }
}